"use client";

import { c as _c } from "react/compiler-runtime";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { buttonStyles } from "@/components/ui/button";
import { Link } from "@/components/ui/link";
export default function AdminNotFound() {
  const $ = _c(4);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ExclamationTriangleIcon className="size-16 text-muted-fg" />;
    t1 = <h1 className="text-2xl font-semibold">Sayfa Bulunamadı</h1>;
    t2 = <p className="text-muted-fg">Aradığınız sayfa mevcut değil veya taşınmış olabilir.</p>;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex min-h-[50vh] flex-col items-center justify-center gap-4">{t0}{t1}{t2}<Link href="/" className={buttonStyles({
        intent: "warning"
      })}>Ana Sayfaya Dön</Link></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}